import { Link } from 'react-router-dom';
import { getResizedImageUrl } from '../lib/cms';

export default function ServicesPage() {
  const serviceCategories = [
    {
      title: 'Indendørs Projekter',
      slug: 'indendors-projekter',
      href: '/indendors-projekter',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg',
      badge: 'Indvendigt malerarbejde',
      desc: 'Professionelt indendørs malerarbejde med fokus på kvalitet og service. Vi hjælper med maling af vægge, lofter, træværk, døre, trapper samt tapetsering og spartling.',
      bullets: [
        'Maling af stuer, værelser og lofter',
        'Spartling, glasfilt og opsætning af væv',
        'Maling af trapper, gelændere, døre og paneler',
        'Dekorativt malerarbejde og mønstret tapet'
      ]
    },
    {
      title: 'Udendørsprojekter',
      slug: 'udendors-projekter',
      href: '/udendors-projekter',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg',
      badge: 'Udvendigt malerarbejde',
      desc: 'Beskyt dit hus mod det nordjyske vind og vejr. Vi udfører professionelt udendørs malerarbejde af facader, træværk, vinduer, udhæng og carporte med holdbare kvalitetsprodukter.',
      bullets: [
        'Træbeskyttelse af sorte, malede og bejdsede træhuse',
        'Facademaling af pudsede og murede facader',
        'Maling af udendørs døre, vinduer og carporte',
        'Sokkelbehandling og udvendigt vedligehold'
      ]
    },
    {
      title: 'Maler i Nørresundby',
      slug: 'maler-norresundby',
      href: '/maler-norresundby',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240807-125724-scaled.jpg',
      badge: 'Lokalt område',
      desc: 'Din lokale maler i Nørresundby og Lindholm. Vi tilbyder både indvendigt og udvendigt malerarbejde i høj kvalitet for private husstande, boligforeninger og erhverv.',
      bullets: [
        'Hurtig responstid og lokal rådgivning',
        'Projekter i klassiske villaer og nybyggeri',
        'Gratis besigtigelse og uforpligtende tilbud'
      ]
    },
    {
      title: 'Maler i Brønderslev',
      slug: 'maler-bronderslev',
      href: '/maler-bronderslev',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112222-scaled.jpg',
      badge: 'Lokalt område',
      desc: 'Mangler du en maler i Brønderslev? Carsten Janum leverer solidt malerarbejde med fokus på godt håndværk, grundigt forarbejde og ordentlige aftaler.',
      bullets: [
        '20 års erfaring i Brønderslev og omegn',
        'Indvendige og udvendige opfriskninger',
        'Faste aftaler og gennemskuelige priser'
      ]
    },
    {
      title: 'Maler i Støvring',
      slug: 'maler-stovring',
      href: '/maler-stovring',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112728-scaled.jpg',
      badge: 'Lokalt område',
      desc: 'Leder du efter en professionel maler i Støvring? Vi hjælper både private og erhverv med alt fra renovering af parcelhuse og rækkehuse til udvendig facademaling.',
      bullets: [
        'Skræddersyet rådgivning om farver og materialer',
        'Præcisionsarbejde ved både små og store opgaver',
        'Personlig kontakt direkte med malermesteren'
      ]
    }
  ];

  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      {/* Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-16 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Vores Malerydelser
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              Kvalitetsmalerarbejde til private & erhverv
            </h1>
            <p className="text-gray-200 text-lg">
              Vi tilbyder et bredt udvalg af faglige løsninger inden for malerfaget – altid med fokus på grundigt forarbejde, holdbarhed og et flot finish.
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        {serviceCategories.map((service, index) => (
          <div
            key={service.slug}
            className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 grid grid-cols-1 lg:grid-cols-12 gap-0"
          >
            <div className={`lg:col-span-5 relative min-h-[280px] ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
              <img
                src={getResizedImageUrl(service.image, 800, 85)}
                alt={service.title}
                className="w-full h-full object-cover absolute inset-0"
              />
            </div>

            <div className={`lg:col-span-7 p-8 sm:p-10 flex flex-col justify-between space-y-6 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
              <div className="space-y-4">
                <span className="inline-block px-3 py-1 bg-[#1D352E]/10 text-[#1D352E] text-xs font-semibold uppercase tracking-wider rounded-full">
                  {service.badge}
                </span>
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
                  {service.title}
                </h2>
                <p className="text-gray-700 leading-relaxed text-base">
                  {service.desc}
                </p>

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 pt-2 text-sm text-gray-700">
                  {service.bullets.map((bullet, bIdx) => (
                    <li key={bIdx} className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-[#65237e] text-xs" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-4 border-t border-gray-100 flex flex-wrap items-center gap-4">
                <Link
                  to={service.href}
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl transition-colors shadow-sm"
                >
                  <span>Læs mere om {service.title}</span>
                  <i className="fa-solid fa-arrow-right text-xs" />
                </Link>

                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-[#1D352E] bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors"
                >
                  Få et tilbud
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
